













































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import moment from "moment";
import {
  ScheduleTransfer,
  ListEmployeeWithHourSchedule,
  Schedule,
  ScheduleService,
} from "@/api";

@Component
export default class TransferRequestsTab extends Vue {
  loading = false;
  actioningId: number | null = null;
  confirmAcceptDialog = false;
  acceptHoursWarning = "";
  pendingTransfer: ScheduleTransfer | null = null;

  selectedTransfer: ScheduleTransfer | null = null;
  selectedSchedule: Schedule | null = null;
  loadingSchedule = false;

  snackbar = {
    show: false,
    message: "",
    color: "success",
    icon: "mdi-check-circle",
  };

  get transfers(): ScheduleTransfer[] {
    return this.$store.getters["scheduleTransfer/schedules"] || [];
  }

  isSelected(transfer: ScheduleTransfer): boolean {
    return !!this.selectedTransfer && this.selectedTransfer.id === transfer.id;
  }

  async mounted() {
    await this.refresh();
  }

  async refresh() {
    this.loading = true;
    try {
      const fetchTransfers = this.$store.dispatch(
        "scheduleTransfer/fetchSchedules",
      );
      const fetchEmployees = this.$store.dispatch("schedule/listEmployeList");
      await Promise.all([fetchTransfers, fetchEmployees]);
    } catch (error) {
      console.error("Failed to fetch transfer requests:", error);
    } finally {
      this.loading = false;
    }
  }

  async updateStatus(
    transfer: ScheduleTransfer,
    status: "accepted" | "rejected",
  ) {
    if (!transfer.id || !transfer.scheduleId) return;

    if (status === "accepted") {
      const employees: ListEmployeeWithHourSchedule[] =
        this.$store.state.schedule?.employees || [];
      const targetEmp = employees.find(e => e.id === transfer.toAssigneeId);
      const totalHours = targetEmp?.totalHours ?? 0;

      if (totalHours >= 40) {
        const empName =
          transfer.toAssigneeName ||
          (targetEmp
            ? `${targetEmp.firstName || ""} ${targetEmp.lastName || ""}`.trim()
            : `Employee #${transfer.toAssigneeId}`);
        this.acceptHoursWarning = `${empName} already has ${totalHours} scheduled hours this week (at or above the 40-hour limit).`;
        this.pendingTransfer = transfer;
        this.confirmAcceptDialog = true;
        return;
      }
    }

    await this.executeStatusUpdate(transfer, status);
  }

  async confirmAccept() {
    if (!this.pendingTransfer) return;
    const transfer = this.pendingTransfer;
    this.confirmAcceptDialog = false;
    this.pendingTransfer = null;
    await this.executeStatusUpdate(transfer, "accepted");
  }

  async executeStatusUpdate(
    transfer: ScheduleTransfer,
    status: "accepted" | "rejected",
  ) {
    if (!transfer.id || !transfer.scheduleId) return;
    this.actioningId = transfer.id;
    try {
      await this.$store.dispatch("scheduleTransfer/updateScheduleStatus", {
        scheduleId: transfer.scheduleId,
        scheduleTransferId: transfer.id,
        schedule: {
          id: transfer.id,
          scheduleId: transfer.scheduleId,
          status,
          fromAssigneeId: transfer.fromAssigneeId,
          toAssigneeId: transfer.toAssigneeId,
        } as ScheduleTransfer,
      });
      this.selectedTransfer = null;
      this.selectedSchedule = null;
      this.showSnackbar(
        status === "accepted"
          ? "Transfer request accepted."
          : "Transfer request rejected.",
        status === "accepted" ? "success" : "error",
        status === "accepted" ? "mdi-check-circle" : "mdi-close-circle",
      );
    } catch (error) {
      console.error("Failed to update transfer status:", error);
    } finally {
      this.actioningId = null;
    }
  }

  getScheduleDate(transfer: ScheduleTransfer) {
    const schedule = (this.$store.state.schedule?.schedules || []).find(
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (s: any) => s.id === transfer.scheduleId,
    );
    return schedule
      ? this.formatDate(schedule.date)
      : this.formatDate(transfer.createdAt);
  }

  async openTransferDetails(transfer: ScheduleTransfer) {
    this.selectedTransfer = transfer;
    this.selectedSchedule = null;

    if (transfer.scheduleId) {
      const localSchedule = (this.$store.state.schedule?.schedules || []).find(
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (s: any) => s.id === transfer.scheduleId,
      );
      if (localSchedule) {
        this.selectedSchedule = localSchedule;
      } else {
        const companyId = this.$store.state.appContext.company?.id;
        if (companyId) {
          this.loadingSchedule = true;
          try {
            this.selectedSchedule = await ScheduleService.getScheduleById({
              companyId,
              scheduleId: transfer.scheduleId,
            });
          } catch (error) {
            console.error("Failed to fetch schedule details:", error);
          } finally {
            this.loadingSchedule = false;
          }
        }
      }
    }
  }

  formatDate(dateStr?: string | null) {
    if (!dateStr) return "—";
    const d = moment(dateStr);
    if (d.isSame(moment(), "day")) return "Today";
    if (d.isSame(moment().add(1, "day"), "day")) return "Tomorrow";
    return d.format("ddd, MMM D");
  }

  getStatusColor(status?: string) {
    switch (status) {
      case "accepted":
        return "success";
      case "rejected":
      case "cancelled":
        return "error";
      case "pending":
        return "warning";
      default:
        return "grey";
    }
  }

  showSnackbar(message: string, color: string, icon: string) {
    this.snackbar = { show: true, message, color, icon };
  }
}
